import MarkdownIt from "markdown-it";

const md = new MarkdownIt({ html: true, linkify: true, typographer: true });

// Add target="_blank" to all links
md.renderer.rules.link_open = (tokens, idx, options, _env, self) => {
	const token = tokens[idx];

	// Add target="_blank"
	const targetIndex = token.attrIndex("target");
	if (targetIndex < 0) {
		token.attrPush(["target", "_blank"]);
	} else if (token.attrs) {
		token.attrs[targetIndex][1] = "_blank";
	}

	// Optional: Add rel="noopener noreferrer"
	const relIndex = token.attrIndex("rel");
	if (relIndex < 0) {
		token.attrPush(["rel", "noopener noreferrer"]);
	} else if (token.attrs) {
		token.attrs[relIndex][1] = "noopener noreferrer";
	}

	return self.renderToken(tokens, idx, options);
};

export default md;
